jQuery(document).ready(function($) {
    var isMobileView = $(window).width() < 768;

    // Toggle dropdown visibility on button click
    $('.kurs--filter-button').on('click', function(e) {
        e.stopPropagation();
        var $dropdown = $(this).siblings('.kurs--filter-dropdown');
        var $icon = $(this).find('.kurs--filter-icon');
        
        // Close other dropdowns and reset their icons
        $('.kurs--filter-dropdown').not($dropdown).hide();
        $('.kurs--filter-icon').not($icon).removeClass('open');
        
        $dropdown.toggle();
        $icon.toggleClass('open');
    });

    // Handle course selection (redirect)
    $('.kurs--filter-dropdown li[data-url]').on('click', function() {
        var url = $(this).data('url');
        if (url) {
            window.location.href = url;
        }
        $(this).closest('.kurs--filter').find('.kurs--filter-icon').removeClass('open');
        $(this).closest('.kurs--filter-dropdown').hide(); // Close dropdown
    });

    // Handle weekday selection (scroll)
    $('.kurs--filter-dropdown li[data-target]').on('click', function() {
        var targetId = $(this).data('target');
        if (targetId) {
            $('html, body').animate({
                scrollTop: $('#' + targetId).offset().top
            }, 500); // Smooth scroll over 500ms
        }
        $(this).closest('.kurs--filter').find('.kurs--filter-icon').removeClass('open');
        $(this).closest('.kurs--filter-dropdown').hide(); // Close dropdown
    });

    // Close dropdowns when clicking outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.kurs--filter').length) {
            $('.kurs--filter-dropdown').hide();
            $('.kurs--filter-icon').removeClass('open');
        }
    });

    // Accordion functionality for weekday tables (mobile only)
    function initAccordion(isMobile) {
        
        // Only initialize on mobile screens
        if (isMobile) {
            // Ensure all content is hidden initially on mobile
            $('.kursplan--day').each(function() {
                var $day = $(this);
                var $content = $day.find('.kursplan--day-content');
                if (!$day.hasClass('active')) {
                    $content.hide();
                }
            });
            $('.kursplan--day').removeClass('active');
            $('.kursplan--accordion-icon').removeClass('rotated');
            
            // Set up click handlers
            $('.kursplan--day-header').off('click.accordion').on('click.accordion', function(e) {
                e.preventDefault();
                var $day = $(this).closest('.kursplan--day');
                var $content = $day.find('.kursplan--day-content');
                var $icon = $(this).find('.kursplan--accordion-icon');
                var isActive = $day.hasClass('active');
                
                if (isActive) {
                    // Close it
                    $day.removeClass('active');
                    $content.slideUp(300);
                    $icon.removeClass('rotated');
                } else {
                    // Open it
                    $day.addClass('active');
                    $content.slideDown(300);
                    $icon.addClass('rotated');
                }
            });
        } else {
            // Remove click handlers on desktop
            $('.kursplan--day-header').off('click.accordion');
            // Ensure all content is visible on desktop
            $('.kursplan--day-content').show();
            $('.kursplan--day').removeClass('active');
            $('.kursplan--accordion-icon').removeClass('rotated');
        }
    }

    // Initialize on load
    initAccordion(isMobileView);

    // Re-initialize only when viewport crosses mobile breakpoint.
    // Mobile browsers fire resize while scrolling (address bar collapse),
    // so re-running init on every resize would close open accordions.
    var resizeTimer;
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            var nextIsMobileView = $(window).width() < 768;
            if (nextIsMobileView !== isMobileView) {
                isMobileView = nextIsMobileView;
                initAccordion(isMobileView);
            }
        }, 250);
    });
});